<div class="pcp-overlay">
  <mat-dialog-content>
    <div class="confirmation">
      {{ 'pcp_deselect_overlay_are_you_sure' | translate }}
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <zelis-button
      [href]="data.deselectLink"
      data-cy="pcp-deselect-overlay.yes"
      mat-dialog-close
      variant="basic"
      color="accent"
    >
      {{ 'pcp_deselect_overlay_continue' | translate }}
    </zelis-button>
    <zelis-button
      data-cy="pcp-deselect-overlay.no"
      mat-dialog-close
      variant="basic"
      class="ml-2"
    >
      {{ 'pcp_overlay_no' | translate }}
    </zelis-button>
  </mat-dialog-actions>
</div>
